export function copyCurrentUrlToClipboard() {
    return navigator.clipboard.writeText(window.location.href);
}
/** Label + click handler: "Copy link" → "Copied" → reset after timeout. */
export function createCopyLinkAction(koLib, timeoutMs = 2000) {
    const copyLinkLabel = koLib.observable("Copy link");
    let resetTimer = null;
    async function onCopyLink() {
        await copyCurrentUrlToClipboard();
        copyLinkLabel("Copied");
        if (resetTimer !== null) {
            clearTimeout(resetTimer);
        }
        resetTimer = setTimeout(() => {
            copyLinkLabel("Copy link");
            resetTimer = null;
        }, timeoutMs);
    }
    return { copyLinkLabel, onCopyLink };
}
